import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { olVariants } from "./Ol.variants.js";
const Ol_Ol = /*#__PURE__*/ forwardRef(function({ className, children, ...props }, ref) {
    const classes = cn(olVariants(props), className);
    const domProps = cleanProps(props, Object.keys(olVariants.variants));
    return /*#__PURE__*/ jsx("ol", {
        ref: ref,
        className: classes,
        ...domProps,
        children: children
    });
});
export { Ol_Ol as Ol };
